import { FunctionComponent, useState } from 'react';
import classnames from 'classnames';

import { shorten } from 'utils/string';

import Button, { ButtonElements, ButtonIconPositions, ButtonIconTypes, ButtonVariants } from 'components/layout/Button';
import LayoutContainer from 'components/layout/LayoutContainer';
import Description from 'components/modules/public/layout/sections/Description';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageLocationSectionCheckout: FunctionComponent<Props> = ({ locale, collapseButton, subheadline, expandButton }) => {
    const [expandDescription, setExpandDescription] = useState(false);
    const description = expandDescription
        ? locale?.description
        : shorten(locale?.description || '', 1000, true);

    const onControlClick = (): void => {
        setExpandDescription(!expandDescription);

        if (expandDescription) {
            const elem = document.getElementById('desc-headline');

            elem?.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    };

    return (
        <StyledComponent className="public-page-location-section-checkout">
            <LayoutContainer>
                <Description
                    headline={locale.name}
                    subheadline={subheadline}
                    description={description}
                />

                <div className="section-control">
                    <Button
                        onClick={() => onControlClick()}
                        icon={{
                            value: '/images/home/arrow-down.svg',
                            position: ButtonIconPositions.After,
                            type: ButtonIconTypes.Image,
                        }}
                        variant={ButtonVariants.Outline}
                        element={ButtonElements.Button}
                        className={classnames(expandDescription && 'expand-state')}
                    >
                        {expandDescription ? collapseButton: expandButton}
                    </Button>
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageLocationSectionCheckout;
